export const defaultCheckoutCategory = (checkoutCategories = []) => {
  return checkoutCategories[0] || null;
};

export const findCheckoutCategoryById = (checkoutCategories = [], checkoutCategoryId) => {
  if(checkoutCategoryId === null || checkoutCategoryId === undefined || checkoutCategoryId === ""){
    return null;
  }

  const normalizedCheckoutCategoryId = parseInt(checkoutCategoryId, 10);

  if(Number.isNaN(normalizedCheckoutCategoryId)){
    return null;
  }

  return checkoutCategories.find((checkoutCategory) => {
    return checkoutCategory.id === normalizedCheckoutCategoryId;
  }) || null;
};

export const resolveActiveCheckoutCategory = (checkoutCategories = [], checkoutCategoryId, currentCheckoutCategory = null) => {
  const requestedCheckoutCategory = findCheckoutCategoryById(checkoutCategories, checkoutCategoryId);

  if(requestedCheckoutCategory){
    return requestedCheckoutCategory;
  }

  if(
    currentCheckoutCategory
      && checkoutCategories.some((checkoutCategory) => checkoutCategory.id === currentCheckoutCategory.id)
  ){
    return currentCheckoutCategory;
  }

  return defaultCheckoutCategory(checkoutCategories);
};
